<div
  [ngClass]="{
    'dark-theme': alayticsService.currentTheme === 'material-dark',
  }"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="route.url.includes('dashboard')"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  ></ngx-spinner>

  <div class="row">
    <div
      class="col-md-12 justify-content-between"
      [ngClass]="{ 'd-flex': !storageService.detectMob(), 'd-block': storageService.detectMob() }"
    >
      <div class="d-flex justify-content-between w-100">
        <h5 class="quicksand-bold-label font-weight-bold text-dark">User Signup Activity</h5>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <nb-tabset class="login-tabs p-0" (changeTab)="onTabChange($event)">
    <nb-tab tabTitle="Teachers Only">
      <ng-template nbTabTitle>
        <span class="quicksand-bold-label text-capitalize pt-1">Teachers Only</span>
        <span class="quicksand-bold-label tab-count">{{ teacherOnlyUserCount }}</span>
      </ng-template>
      <ng-container *ngTemplateOutlet="userTabTemplate; context: { userList: teacherUsers, isEduPlatform: false }"></ng-container>
    </nb-tab>

    <nb-tab tabTitle="EDU School Platform">
      <ng-template nbTabTitle>
        <span class="quicksand-bold-label text-capitalize pt-1">EDU School Platform</span>
        <span class="quicksand-bold-label tab-count">{{ eduPlatformUserCount }}</span>
      </ng-template>
      <ng-container *ngTemplateOutlet="userTabTemplate; context: { userList: eduPlatformUsers, isEduPlatform: true }"></ng-container>
    </nb-tab>
  </nb-tabset>

  <ng-template #userTabTemplate let-userList="userList" let-isEduPlatform="isEduPlatform">
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <div class="text-start">
        <label class="quicksand-bold-label dark-mode-label-color" *ngIf="!storageService.detectMob()">
          Click on a user to view the profile.
        </label>
        <label class="quicksand-bold-label dark-mode-label-color tap-card" *ngIf="storageService.detectMob()">
          Tap on a card to view the profilr.
        </label>
      </div>

      <div class="d-flex flex-wrap">
        <div class="has-search d-flex justify-content-center" [ngClass]="{ 'mb-2': storageService.detectMob() }">
          <img src="/assets/icons/search.svg" alt="search-icon" height="17" width="17" class="search-icon" />
          <input type="text" class="form-control" placeholder="Search User" [(ngModel)]="searchText" [formControl]="searchControl" />
        </div>

        <mat-form-field appearance="outline" class="d-flex justify-content-center signup-activity-select-option">
          <mat-label>Filter By Status</mat-label>
          <mat-select [(ngModel)]="selectedOption" (selectionChange)="filterUsersByRole($event.value)" name="type">
            <mat-option class="quicksand-bold-label signup-activity-options" *ngFor="let status of filterOptions" [value]="status.value">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Desktop Table -->
    <div class="row">
      <div class="col-md-12">
        <table
          class="table table-hover table-small mt-2 teacher-list-table table-border-radius"
          *ngIf="!storageService.detectMob() && (userList | userSearch: searchText).length > 0"
        >
          <thead>
            <tr class="table-header-row table-header-dark">
              <th class="main-header text-center">Profile</th>
              <th class="main-header text-center">Name</th>
              <th class="main-header text-center">
                {{ isEduPlatform ? 'Role' : 'Subjects' }}
              </th>
              <th class="main-header text-center">Email</th>
              <th class="main-header text-center">Location</th>
              <th class="main-header text-center">Onboarding Status</th>
              <th class="main-header text-center" *ngIf="!isEduPlatform">Pacing Plans /<br />Classes</th>
              <th class="main-header text-center" *ngIf="!isEduPlatform">Lesson Plans /<br />Standards (To Date)</th>
              <th class="main-header text-center" *ngIf="!isEduPlatform">Subscription Plans</th>
              <th class="main-header text-center" *ngIf="isEduPlatform">Last Login</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let user of userList | userSearch: searchText"
              class="cursor-pointer user-list"
              (click)="showTeacherDashboard(user)"
            >
              <td class="text-center align-middle">
                <div class="profile-container">
                  <img
                    *ngIf="user.user_activity_status"
                    [src]="getStatusImagePath(user.user_activity_status)"
                    class="dot-content"
                    alt="profile-status"
                  />

                  <!-- Default Image -->
                  <img
                  *ngIf="utilService.getProfileImage(user)"
                    src="/assets/images/no-profile-image.png"
                    height="35"
                    width="35"
                    class="profile-img"
                    alt="profile-image"
                  />

                  <img
                   *ngIf="!utilService.getProfileImage(user)"
                    [src]="user?.user_profile_media?.image?.url"
                    height="35"
                    width="35"
                    class="profile-img"
                    alt="profile-image"
                  />
                </div>
              </td>
              <td class="text-center align-middle">{{ user?.firstName | titlecase }} {{ user?.lastName | titlecase }}</td>
              <td class="text-center align-middle overflow-ellipsis" matTooltip="{{ user?.teachingSubjectName ?? user?.role.name }}">
                {{ isEduPlatform ? user?.role.name : (user?.teachingSubjectName ?? '-') }}
              </td>
              <td class="text-center align-middle text-break">{{ user.email }}</td>

              <td class="text-center align-middle">
                {{
                  user.last_login_location?.region && user.last_login_location?.country_name
                    ? user.last_login_location.region + ', ' + user.last_login_location.country_name
                    : user.last_login_location?.state && user.last_login_location?.country
                      ? user.last_login_location.state + ', ' + user.last_login_location.country
                      : '-'
                }}
              </td>

              <!-- <td class="text-center align-middle text-break">{{ user.last_login_location ? user.last_login_location : '-' }}</td> -->
              <td class="text-center align-middle">
                <div [ngClass]="user.isNewUser ? 'pending-status' : 'text-success'">
                  {{ user.isNewUser ? 'Pending' : 'Completed' }}
                </div>
              </td>
              <td
                class="text-center align-middle child-loading-element"
                [nbSpinner]="childLoading"
                size="tiny"
                nbSpinnerSize="small"
                nbSpinnerStatus="primary"
                *ngIf="!isEduPlatform"
              >
                <div
                  *ngIf="!childLoading"
                  [ngClass]="{
                    'text-success':
                      (user?.countClassWithPlans || 0) === (user?.classroom_list?.length || 0) && (user?.countClassWithPlans || 0) !== 0,
                    'text-danger': (user?.countClassWithPlans || 0) !== (user?.classroom_list?.length || 0),
                  }"
                >
                  {{ user?.countClassWithPlans || 0 }}/{{ user?.classroom_list?.length || 0 }}
                </div>
              </td>
              <td
                class="text-center align-middle child-loading-element"
                [nbSpinner]="childLoading"
                size="tiny"
                nbSpinnerSize="small"
                nbSpinnerStatus="primary"
                *ngIf="!isEduPlatform"
              >
                <div
                  *ngIf="!childLoading"
                  [ngClass]="{
                    'text-success':
                      (user?.total_lesson_plan || 0) === (user?.totalLessonPlans || 0) && (user?.total_lesson_plan || 0) !== 0,
                    'text-danger': (user?.total_lesson_plan || 0) !== (user?.totalLessonPlans || 0),
                  }"
                >
                  {{ user?.total_lesson_plan || 0 }}/
                  {{ user?.totalLessonPlans ? user?.totalLessonPlans : 0 }}
                </div>
              </td>
              <td
                class="text-center align-middle child-loading-element"
                [nbSpinner]="childLoading"
                size="tiny"
                nbSpinnerSize="small"
                nbSpinnerStatus="primary"
                *ngIf="!isEduPlatform"
              >
                <div
                  *ngIf="!childLoading"
                  [ngClass]="{
                    'text-success': user?.subscription_details?.subscription_status === 'active',
                    'text-danger': user?.subscription_details?.subscription_status !== 'active',
                  }"
                >
                  {{ (user?.subscription_details?.plan_type ? user?.subscription_details?.plan_type : 'free') | titlecase }}
                </div>
              </td>
              <td class="user-data text-center align-middle" *ngIf="isEduPlatform">
                {{
                  user?.last_user_activity_log_of_user
                    ? ((user?.last_user_activity_log_of_user.expired_time
                        ? user?.last_user_activity_log_of_user.expired_time
                        : user?.last_user_activity_log_of_user.created_at
                      ) | date: 'MM-dd-yyyy')
                    : '-'
                }}
                <br />
                {{
                  user?.last_user_activity_log_of_user
                    ? ((user?.last_user_activity_log_of_user.expired_time
                        ? user?.last_user_activity_log_of_user.expired_time
                        : user?.last_user_activity_log_of_user.created_at
                      ) | date: 'hh:mm a')
                    : ''
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile Cards -->
        <div *ngIf="storageService.detectMob() && (userList | userSearch: searchText).length > 0">
          <nb-card
            *ngFor="let user of userList | userSearch: searchText"
            class="cursor-pointer user-card"
            (click)="showTeacherDashboard(user)"
          >
            <nb-card-body class="row">
              <div class="col-12 mb-1">
                <div class="profile-container">
                  <img
                    *ngIf="user.user_activity_status"
                    [src]="getStatusImagePath(user.user_activity_status)"
                    class="dot-content"
                    alt="profile-status"
                  />

                  <img
                   *ngIf="utilService.getProfileImage(user)"
                    src="/assets/images/no-profile-image.png"
                    height="43"
                    width="43"
                    class="profile-img"
                    alt="profile-imgage"
                  />
                  <img
                  *ngIf="!utilService.getProfileImage(user)"
                    [src]="user?.user_profile_media?.image?.url"
                    height="43"
                    width="43"
                    class="profile-img"
                    alt="profile-imgage"
                  />

                  <label class="name-content">{{ user?.firstName | titlecase }} {{ user?.lastName | titlecase }}</label>
                </div>
              </div>

              <div class="col-3 mt-2">
                <label class="title">{{ isEduPlatform ? 'Role' : 'Subject' }}:</label>
              </div>
              <div class="col-9 mt-2">
                <label class="title-contents overflow-ellipsis">{{
                  isEduPlatform ? user?.role.name : (user?.teachingSubjectName ?? '-')
                }}</label>
              </div>

              <div class="col-3 mt-2"><label class="title">Email:</label></div>
              <div class="col-9 mt-2">
                <label class="title-contents text-break">{{ user?.email ?? '-' }}</label>
              </div>

              <div class="col-3 mt-2"><label class="title">Location:</label></div>
              <div class="col-9 mt-2">
                <label class="title-contents text-break">{{ user?.address ? user?.address : '-' }}</label>
              </div>

              <div class="col-3 mt-2"><label class="title">Onboarding Status:</label></div>
              <div class="col-9 mt-2">
                <label class="title-contents" [ngClass]="user.isNewUser ? 'text-danger' : 'text-success'">
                  {{ user.isNewUser ? 'Pending' : 'Completed' }}
                </label>
              </div>
              <div class="w-100 d-flex" *ngIf="!isEduPlatform">
                <div class="col-md-3 col-sm-4 col-3">
                  <label class="title">Pacing Plans/ Classes:</label>
                </div>
                <div class="col-md-9 col-sm-8 col-9">
                  <label
                    class="title-contents"
                    [ngClass]="{
                      'text-success':
                        (user?.countClassWithPlans || 0) === (user?.classroom_list?.length || 0) && (user?.countClassWithPlans || 0) !== 0,
                      'text-danger':
                        (user?.countClassWithPlans || 0) !== (user?.classroom_list?.length || 0) ||
                        ((user?.countClassWithPlans || 0) === 0 && (user?.classroom_list?.length || 0) === 0),
                    }"
                    >{{ user?.countClassWithPlans ? user?.countClassWithPlans : 0 }}/{{
                      user?.classroom_list ? user?.classroom_list?.length : 0
                    }}</label
                  >
                </div>
              </div>
              <div class="w-100 d-flex" *ngIf="!isEduPlatform">
                <div class="col-md-3 col-sm-4 col-3">
                  <label class="title">Lesson Plans/ Standards (To Date): </label>
                </div>
                <div class="col-md-9 col-sm-8 col-9">
                  <label
                    class="title-contents"
                    [ngClass]="{
                      'text-success':
                        (user?.total_lesson_plan || 0) === (user?.totalLessonPlans || 0) && (user?.total_lesson_plan || 0) !== 0,
                      'text-danger':
                        (user?.total_lesson_plan || 0) !== (user?.totalLessonPlans || 0) ||
                        ((user?.total_lesson_plan || 0) === 0 && (user?.totalLessonPlans || 0) === 0),
                    }"
                  >
                    {{ user?.total_lesson_plan ? user?.total_lesson_plan : 0 }}/{{ user?.totalLessonPlans ? user?.totalLessonPlans : 0 }}
                  </label>
                </div>
              </div>
              <div class="w-100 d-flex" *ngIf="!isEduPlatform">
                <div class="col-md-3 col-sm-4 col-3">
                  <label class="title">Subscription Plans: </label>
                </div>
                <div class="col-md-9 col-sm-8 col-9">
                  <label
                    class="title-contents"
                    [ngClass]="{
                      'text-success': user?.subscription_details?.subscription_status === 'active',
                      'text-danger': user?.subscription_details?.subscription_status !== 'active',
                    }"
                  >
                    {{ (user?.subscription_details?.plan_type ? user?.subscription_details?.plan_type : 'free') | titlecase }}
                  </label>
                </div>
              </div>
              <div class="w-100 d-flex" *ngIf="isEduPlatform">
                <div class="col-md-3 col-sm-4 col-3">
                  <label class="title">Last Login:</label>
                </div>
                <div class="col-md-9 col-sm-8 col-9">
                  <label class="title-contents">
                    {{
                      user?.last_user_activity_log_of_user
                        ? ((user?.last_user_activity_log_of_user.expired_time
                            ? user?.last_user_activity_log_of_user.expired_time
                            : user?.last_user_activity_log_of_user.created_at
                          ) | date: 'MM-dd-yyyy')
                        : '-'
                    }}
                    <br />
                    {{
                      user?.last_user_activity_log_of_user
                        ? ((user?.last_user_activity_log_of_user.expired_time
                            ? user?.last_user_activity_log_of_user.expired_time
                            : user?.last_user_activity_log_of_user.created_at
                          ) | date: 'hh:mm a')
                        : ''
                    }}
                  </label>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </div>
    <h6 class="quicksand-bold-label text-center" *ngIf="(userList | userSearch: searchText).length === 0">
      <img src="/assets/images/respond-edu.svg" alt="no-events-found" height="100" width="100" />
      <br />
      No Users Found
    </h6>

    <ng-container *ngIf="isPaginate && (userList | userSearch: searchText).length > 0">
      <hr style="margin-top: 0" class="hr-color" *ngIf="currentPage !== 1 || userList?.length > 0" />
      <div class="pagination d-flex justify-content-between" style="margin-bottom: 35px" *ngIf="currentPage !== 1 || userList?.length > 0">
        <div class="pt-2">
          <span class="pagination-numbers-count quicksand-bold-label"> Page {{ currentPage }} of {{ totalPages }} </span>
        </div>
        <div>
          <button
            class="btn-paginate mr-2 quicksand-bold-label"
            [disabled]="currentPage === 1"
            (click)="currentPage = currentPage - 1; getListByPage()"
          >
            <label *ngIf="!storageService.detectMob()" class="mb-0"> Previous</label>
            <nb-icon icon="arrow-back-outline" *ngIf="storageService.detectMob()"> </nb-icon>
          </button>
          <nb-select
            placeholder="Select Page"
            class="mr-2 select-button"
            [(selected)]="currentPage"
            (selectedChange)="currentPage = $event; getListByPage()"
            *ngIf="!storageService.detectMob()"
          >
            <nb-option [value]="page" *ngFor="let page of pages">{{ page }} </nb-option>
          </nb-select>

          <button
            class="btn-paginate quicksand-bold-label"
            (click)="currentPage = currentPage + 1; getListByPage()"
            [disabled]="currentPage === totalPages"
            [ngClass]="storageService.detectMob() ? 'mr-2' : ' '"
          >
            <label *ngIf="!storageService.detectMob()" class="mb-0"> Next</label>
            <nb-icon icon="arrow-forward-outline" *ngIf="storageService.detectMob()"> </nb-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
